import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericField } from '../../classes/generic-field';

@Component({
  selector: 'app-cv-field',
  templateUrl: './customer-verification-field.component.html',
  styleUrls: ['./customer-verification-field.component.css']
})
export class CustomerVerificationFieldComponent  implements OnInit {

  @Input() cvField!: GenericField<string>;
  @Input() form!: FormGroup;

  constructor() { }

  ngOnInit(): void {
  }

  get isValid() {
    return this.form.controls[this.cvField.key].valid; 
  }  
}
